module.exports = __webpack_public_path__ + "/static/assets/85a7793e786650bb42e91693642f26c9.png";